import { render, staticRenderFns } from "./RipaFormTemplate.vue?vue&type=template&id=3865bf7f"
import script from "./RipaFormTemplate.vue?vue&type=script&lang=js"
export * from "./RipaFormTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports